import { Outlet } from "react-router-dom";

export default function Plans() {
    return <Outlet />;
}
